// Libs
import axios from 'axios'

// Action types
export const CHANGE_HEADER_VISIBLE = 'change_header_visible'

export function changeHeaderVisible(type) {
  return {
    type: CHANGE_HEADER_VISIBLE,
    payload: type
  }
}
